// Test IDs for the tickets workspace.
export const TICKETS = {
  page: 'tickets-page',
  sidebar: 'tickets-sidebar',
  sidebarScopeAssigned: 'tickets-scope-assigned',
  sidebarScopeMine: 'tickets-scope-mine',
  dispositionItem: (key) => `tickets-disposition-${key}`,
  filtersBar: 'tickets-filters-bar',
  filterSource: 'tickets-filter-source',
  filterClinic: 'tickets-filter-clinic',
  filterAudiologist: 'tickets-filter-audiologist',
  filterMonth: 'tickets-filter-month',
  filterYear: 'tickets-filter-year',
  searchInput: 'tickets-search-input',
  table: 'tickets-table',
  row: (id) => `ticket-row-${id}`,
  drawer: 'ticket-drawer',
  drawerClose: 'ticket-drawer-close',
  drawerTab: (name) => `ticket-drawer-tab-${name}`,
  changeDispositionSelect: 'ticket-change-disposition',
  changeAssigneeSelect: 'ticket-change-assignee',
  noteInput: 'ticket-note-input',
  noteSubmit: 'ticket-note-submit',
  syncButton: 'tickets-sync-button',
};

export const SYNC = {
  page: 'sync-page',
  triggerButton: 'sync-trigger-button',
  statusBadge: 'sync-status-badge',
};
